<template>
    <input type="text" v-model="text" :class="['cz__text', 'cz__option-text', { 'cz__option--selected': selected }]" @input="personalize">
</template>

<style lang="less">
    .cz__text.cz__option-text {
        padding: 0 10px;

        height: 32px;
        line-height: 32px;

        border: 1px solid #f1f1f1;

        &:focus {
            outline: none;
            border: 1px solid #000;
        }
    }
</style>

<script>
    export default {
        props: {
            controller: Object,
            blueprint: Object,
            option: Object,
            selected: Boolean,
            components: Array,
        },
        data() {
            return {
                text: '',
            };
        },
        watch: {
            components() {
                this.updateText();
            },
        },
        mounted() {
            this.updateText();
        },
        methods: {
            // Updates input text based on the current component state.
            updateText() {
                const selected = this.components.find(c => c.selected);

                if (selected) {
                    if (selected.component.custom && selected.component.custom['personalization-text']) {
                        this.text = selected.component.custom['personalization-text'];
                    }
                }
            },

            personalize() {
                this.$emit('personalization', this.text);
            },
        },
    };
</script>